import T from 'i18n-react'

import {
  select,
  fork,
  put,
  all,
  call,
  takeLatest
} from 'redux-saga/effects'
import { productLineSelector } from 'containers/Project/View/selectors'

import FileSaver from 'file-saver'

import {
  getRequest,
  postRequest,
  post
} from 'helpers/RequestUtil'

import {
  jwtConfig,
  buildFormData,
  formDataHeader
} from 'helpers/RequestUtil'

import {
  FETCH_NVQUAL_REPORT,
  POST_NVQUAL_STATUS,
  CHANGE_CURRENT_REVISION,
  DOWNLOAD_FILES,
  CREATE_NVBUGS
} from './constants'

import {
  updateNvqualRevisions,
  updateNvqualStatusSource,
  updateInitialNvqualRevisionNumber,
  postNvqualEditError,
  updateCurrentRevision,
  fetchStart,
  fetchSuccess,
  fetchError,
  updateNvqualRevisionNumber,
  fetchNvqualReport,
  updateProjectNvqualStatus
} from './actions'
import axios from 'axios'

import {
  curRevisionIdSelector,
  currentRevisionSelector,
  revisionHeadersSelector
} from './selectors'

import {
  commentSelector,
  statusSelector,
  revisionNameSelector
} from 'containers/Project/NvqualSection/EditBox/selectors'

import { projectIdSelector } from 'containers/Project/View/selectors'

import {
  error,
  success,
  info
} from 'containers/App/Notification/actions'
import _ from 'lodash'
import { FETCH_NVQUAL_REPORT_INITIAL } from './constants'

import { ENV } from 'config.js'

function* fetchRevisionHeaders() {

  try {
    yield put(fetchStart())
    const projectId = yield select(projectIdSelector)
    const data = yield call(getRequest, `/api/fulcrum/tool/nvqualreport/fetch_revision_headers?project_id=${projectId}`, jwtConfig())
    return data
  } catch (err) {
    yield put(error(T.translate('pages.project.view.notification.nvqual_fetch_fail')))
    yield console.log(err)
    return err
  }
}

function* fetchRevisionByRevisionId (revId) {
  try {
    yield put(fetchStart())
    const data = yield call(getRequest, `/api/fulcrum/tool/nvqualreport/fetch_revision?revision_id=${revId}`, jwtConfig())
    return data
  } catch (err) {
    yield put(error(T.translate('pages.project.view.notification.nvqual_fetch_fail')))
    yield console.log(err)
    return err
  }
}


function* getRevisionNumberInitial () {
  try {
    yield put(fetchStart())
    const projectId = yield select(projectIdSelector)
    const data = yield call(getRequest, `/api/fulcrum/tool/nvqualreport/fetch_inital_revision_number?project_id=${projectId}`, jwtConfig())
    return data
  } catch (err) {
    yield put(error(T.translate('pages.project.view.notification.nvqual_fetch_fail')))
    yield console.log(err)
    return err
  }
}

function* fetchNvqualStatusSource() {

  try {
    yield put(fetchStart())
    const data = yield call(getRequest, '/api/fulcrum/tool/nvqualreport/source?include=approval', jwtConfig())
    return data
  } catch (err) {
    yield put(error(T.translate('pages.project.view.notification.nvqual_fetch_status_source_fail')))
    yield console.log(err)
    return err
  }
}

function* postCurRevisionNvqualStatus() {

  try {
    yield put(fetchStart())
    const curRevisionId = yield select(curRevisionIdSelector)
    const curRevStatus = yield select(statusSelector)
    const curComment = yield select(commentSelector)
    const curRevisionName = yield select(revisionNameSelector)
    const projectId = yield select(projectIdSelector)
    const info = buildFormData({
      project_id: projectId,
      revision_id: curRevisionId,
      status: curRevStatus,
      comment: curComment,
      revision_name: curRevisionName,
    })
    const config = formDataHeader()
    yield call(
      axios.post,
      '/api/fulcrum/tool/nvqualreport/update_editable',
      info,
      config
    )
    yield put(success(T.translate('pages.project.view.notification.nvqual_update_status_success')))

    const curRevId = yield select(curRevisionIdSelector)
    const { isClosed, headers } = yield call(fetchRevisionHeaders)
    yield put(updateNvqualRevisions(headers))
    yield put(updateProjectNvqualStatus(isClosed))
    const curRev = yield call(fetchRevisionByRevisionId, curRevId)
    yield put(updateCurrentRevision(curRev))

    yield put(fetchSuccess())
  } catch (err) {
    yield put(error(T.translate('pages.project.view.notification.nvqual_update_status_fail')))
    yield console.log(err)
    yield put(fetchError())
    yield put(postNvqualEditError(err))
    return err
  }
}

function* fetchFiles(filePaths, name, isFileName) {
  try {
    if (filePaths.length == 0) return
    yield put(info(T.translate('pages.project.view.notification.nvqual_download_click')))
    const projectId = yield select(projectIdSelector)
    const revisionId = yield select(curRevisionIdSelector)
    const { revision } = yield select(currentRevisionSelector)
    const filesString = filePaths.map(x => `file_ids[]=${x}`).join('&')
    const { data } = yield call(axios.get, 
      `/api/fulcrum/tool/nvqualreport/download_logs?${filesString}`, 
    { ... jwtConfig(), 
      responseType: 'blob'
    })
    let fName = name
    if (isFileName) {
      FileSaver.saveAs(data, name)
    } else {
      fName = `nvqual_inspector_${projectId}_${revision.revisionNumber}_${name}`
      if (!fName.includes('.')) {
        const getFileType = () => filePaths.length > 1 ? '.zip' : '.log'
        fName += getFileType()
      }
      FileSaver.saveAs(data, fName)
    }
    return data
  } catch (err) {
    yield put(error(T.translate('pages.project.view.notification.nvqual_fetch_status_source_fail')))
    yield console.log(err)
    return err
  }
}

function* postNvbugs (revisionId) {
  try {
    yield put (fetchStart())
    const _data = yield call(
      postRequest,
      'nvbug_submit',
      { revision_id: revisionId },
      '/api/fulcrum/tool/nvqualreport/nvbugs_submit'
    )
    yield put(success(T.translate(
      'pages.project.view.notification.nvqual_post_nvbug_success'
    )))
  } catch(error) {
    console.log(error)
    yield put(fetchError(error))
  }
}

function* fetchNvqualReportHandler(){
  const { headers, isClosed } = yield call(fetchRevisionHeaders)

  yield put(updateNvqualRevisions(headers))
  yield put(updateProjectNvqualStatus(isClosed))
  yield put(updateNvqualRevisionNumber(headers[0].revisionNumber))

  const curRevId = yield select(curRevisionIdSelector)
  const curRev = yield call(fetchRevisionByRevisionId, curRevId)
  yield put(updateCurrentRevision(curRev))
  yield put(fetchSuccess())
}

function* onLoadFetchHandler(){
  const { headers, isClosed } = yield call(fetchRevisionHeaders)
  const statusSource = yield call(fetchNvqualStatusSource)

  yield put(updateNvqualStatusSource(statusSource))

  if (headers.length === 0) { //if no revisions found
    yield put(fetchSuccess())
    return
  }

  const revNumber = yield call(getRevisionNumberInitial)

  yield put(updateNvqualRevisions(headers))
  yield put(updateProjectNvqualStatus(isClosed))
  yield put(updateNvqualRevisionNumber(revNumber))

  const curRevId = yield select(curRevisionIdSelector)
  const curRev = yield call(fetchRevisionByRevisionId, curRevId)
  yield put(updateCurrentRevision(curRev))
  yield put(fetchSuccess())
}

function* postCurRevisionNvqualStatusHandler(){
  yield call(postCurRevisionNvqualStatus)
}

function* downloadFilesHandler ({fileIds, name, isFileName}) {
  yield call (fetchFiles, fileIds, name, isFileName)
}

function* changeCurrentRevisionHandler({revNum, revId}) {
  const curRev = yield call(fetchRevisionByRevisionId, revId)
  yield put(updateNvqualRevisionNumber(revNum))
  yield put(updateCurrentRevision(curRev))
  yield put(fetchSuccess())
}

function* postNvbugsHandler ({revisionId, fetchAfter}) {
  yield call (postNvbugs, revisionId)
  if (fetchAfter) {
    yield put(fetchStart())
    const curRevId = yield select(curRevisionIdSelector)
    const { headers, isClosed } = yield call(fetchRevisionHeaders)
    yield put(updateNvqualRevisions(headers))
    yield put(updateProjectNvqualStatus(isClosed))
    const curRev = yield call(fetchRevisionByRevisionId, curRevId)
    yield put(updateCurrentRevision(curRev))

    yield put(fetchSuccess())
  }
}

function* watchFetchNvqualReportInitial() {
  yield takeLatest(FETCH_NVQUAL_REPORT_INITIAL, onLoadFetchHandler)
}

function* watchFetchNvqualReport() {
  yield takeLatest(FETCH_NVQUAL_REPORT, fetchNvqualReportHandler)
}

function* watchDownloadFiles() {
  yield takeLatest(DOWNLOAD_FILES, downloadFilesHandler)
}

function* watchPostCurRevisionNvqualStatus() {
  yield takeLatest(POST_NVQUAL_STATUS, postCurRevisionNvqualStatusHandler)
}

function* watchChangeRevisionHandler() {
  yield takeLatest(CHANGE_CURRENT_REVISION, changeCurrentRevisionHandler)
}

function* watchCreateNvbugs () {
  yield takeLatest(CREATE_NVBUGS, postNvbugsHandler)
}

function* loadSagas() {
  yield all([
    fork(watchFetchNvqualReport),
    fork(watchFetchNvqualReportInitial),
    fork(watchPostCurRevisionNvqualStatus),
    fork(watchChangeRevisionHandler),
    fork(watchDownloadFiles),
    fork(watchCreateNvbugs),
  ])
}

// export default loadSagas
export {
  loadSagas as default,
  postNvbugs
}